import { createContext } from 'react'

export const XStoreEndowmentContext = createContext()
